import Vue from 'vue'
import Router from 'vue-router'
import LeftBar from '@/components/LeftBar'
import Video from '@/components/Video'
import LiveStream from '@/components/LiveStream'
import VideoBrowser from '@/components/VideoBrowser'
import VideoEmbed from '@/components/VideoEmbed'
import About from '@/components/About'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Live',
      components: {
        default: Video,
        left: LeftBar
      },
      children: [{
        name: 'Videos',
        path: 'videos/:slug?',
        components: {
          content: VideoBrowser
        }
      },
      {
        name: 'Channels',
        path: 'channels/:slug?',
        components: {
          content: VideoBrowser
        }
      },
      {
        name: 'Subchannel',
        path: 'channels/:slug/:subChannelSlug',
        components: {
          content: VideoBrowser
        }
      },
      {
        name: 'Themes',
        path: 'themes/:themeSlug?',
        components: {
          content: VideoBrowser
        }
      },
      {
        name: 'Search',
        path: 'search/:searchTerm?',
        components: {
          content: VideoBrowser
        },
        props: { content: true }
      },
      {
        name: 'Related',
        path: 'related/:relatedSlug',
        components: {
          content: VideoBrowser
        },
        props: { content: true }
      },
      {
        name: 'About',
        path: 'about',
        components: {
          content: About
        }
      }]
    },
    {
      path: '/zoom',
      name: 'ZoomingWords',
      component: Video
    },
    {
      name: 'VideoPlayer',
      path: '/videos/:videoId/:slug',
      components: {
        default: Video,
        left: LeftBar
      }
    },
    {
      name: 'VimeoVideoEmbed',
      path: '/video/embed',
      components: {
        default: VideoEmbed
      }
    },
    {
      name: 'Video',
      path: '/video/:slug',
      components: {
        default: Video
      }
    },
    {
      name: 'VideoEmbed',
      path: '/video/:slug/embed',
      components: {
        default: VideoEmbed
      }
    },
    {
      name: 'LiveStream',
      path: '/livestream',
      components: {
        default: LiveStream
      }
    }
  ]
})

function fetchCurrentVideo (to) {
  if (to.query.vimeoId) {
    return { vimeoId: to.query.vimeoId }
  }
  let videoSlug = false
  if (to.hash) {
    videoSlug = to.hash.substring(1)
  } else {
    videoSlug = to.params.slug
  }
  let currentVideo = store.state.videos.find(
    vid => vid.slug === videoSlug
  )
  currentVideo.originalTo = to
  return currentVideo
}

//
// GUARDS
//
router.beforeEach((to, from, next) => {
  if (to.name === 'Video' || (to.name === 'Videos' && to.params.slug) || (to.name === 'Videos' && to.params.slug) || to.hash !== '' || to.name === 'VideoEmbed' || to.name === 'VimeoVideoEmbed') {
    store.dispatch('getVideos').then(() => {
      store.dispatch('updateCurrentVideo', fetchCurrentVideo(to)).then(() => {
        store.commit('LOAD_STOP')
        window.prerenderReady = true
        next()
      })
    })
  } else if (to.name === 'ZoomingWords') {
    store.dispatch('getAllThemes').then(() => {
      window.prerenderReady = true
      next()
    })
  } else {
    store.commit('LOAD_STOP')
    window.prerenderReady = true
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js